var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filled"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "outlined"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "rounded"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "two_x5F_tone"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "sharp"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "win10"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "ios_x5F_out"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "ios_x5F_filled"
  })), /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#40C4FF"
    },
    points: "26,4 6,24 12,30 38,4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#40C4FF"
    },
    points: "38,22 27,33 21,27 26,22  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.757,
    y: 28.757,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -17.1838 24.5147)",
    style: {
      fill: "#03A9F4"
    },
    width: 8.485,
    height: 8.485
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#01579B"
    },
    points: "38,44 26,44 21,39 27,33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#084994"
    },
    points: "21,39 30,36 27,33  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.afd42709f9bd6f76d7c394cff512ca07.svg";
export { ForwardRef as ReactComponent };